<template>
  <div
    class="carNumber"
    :style="{
      border: `1px solid ${colorData(carCardColorDict, 'bor')}`
    }"
  >
    <div
      :style="{
        background: colorData(carCardColorDict, 'bg'),
        color: colorData(carCardColorDict, 'color')
      }"
    >
      {{ plateNo }}
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "HLicensePlate",
  props: {
    carCardColorDict: {
      type: String,
      default: ""
    },
    plateNo: {
      type: String,
      default: ""
    }
  },
  setup() {
    const colorData = (key, is) => {
      let color = "";
      let clortbg = "";
      let clortbor = "";

      switch (key) {
        case "绿":
          color = "#81BC7A";
          break;
        case "黑":
          color = "#fff";
          clortbg = "#000000";
          clortbor = "#000000";
          break;
        case "蓝":
          color = "#fff";
          clortbg = "#0D29E4";
          clortbor = "#0D29E4";
          break;
        case "黄":
          color = "#F9C613";
          break;
        case "白":
          color = "#000";
          clortbg = "#fff";
          clortbor = "#000";
          break;
        case "灰":
          color = "#000";
          clortbg = "#eee";
          clortbor = "#eee";
          break;
        case "紫":
          color = "#fff";
          clortbg = "#7818a5";
          clortbor = "#7818a5";
          break;
        case "红":
          color = "#fff";
          clortbg = "red";
          clortbor = "red";
          break;
        case "棕":
          color = "#fff";
          clortbg = "#3c1d13";
          clortbor = "#3c1d13";
          break;

        case "黄绿":
          break;
        default:
          break;
      }
      if (is === "color") {
        return color;
      } else if (is === "bg") {
        return clortbg;
      } else {
        return clortbor;
      }
    };
    return {
      colorData
    };
  }
});
</script>
<style lang="scss" scoped>
.carNumber {
  // background: red;
  font-weight: bold;
  line-height: 32px;
  text-align: center;
  width: 106px;
  height: 32px;
  color: #fff;
  border-radius: 5px;
  div {
    border-radius: 5px;
    height: calc(100% - 2px);
    margin: 1px;
    width: calc(100% - 2px);
  }
}
</style>
